import { Outlet } from "react-router-dom";

export default function CartesLayout() {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8 min-h-[60vh]">
      <Outlet />
    </div>
  );
}
